import { InternalLinks, ProductCategoryKeys } from '../../../common/enums/common';
import { splunk_message, splunk_log_type } from '../../../common/splunk_constant';
import {
  Kp2020ToolsENUM,
  getCurrentProductData,
  setProfileToolsUsed,
} from '../../../container/seo';
import {
  getProductIdFromUrl,
  getURIAsString,
  getVariantIDFromUrl,
} from '../../../utils/browserUtils';
import { getSession, setSession } from '../../../utils/sessionStorageUtils';
export enum DataAnalyticsTypes {
  Link = 'link',
  Button = 'button',
  Media = 'media',
}
export enum DataAnalyticsLocations {
  Page = 'page',
  Header = 'header',
  Footer = 'footer',
  Body = 'body',
  Banner = 'banner',
  Card = 'card',
  Grid = 'grid',
  Carousel = 'carousel',
  Tile = 'tile',
  MarketingGrid = 'marketinggrid',
  Menu = 'menu',
  Slider = 'slider',
  Dialog = 'dialog',
  Group = 'group',
  List = 'list',
  Palette = 'palette',
}

export enum DataAnalyticsClicks {
  TOOL_VTO = 'tool:vto',
  TOOL_PDMASTER = 'tool:pdmaster',
  FRAME_SELECTED = 'frame:selected',
  ADD_EYEGLASS_FRAME_FAVORITE = 'add:eg:frame:favorite',
  DELETE_EYEGLASS_FRAME_FAVORITE = 'delete:eg:frame:favorite',
  ADD_EG_LENSES = 'add:eg:lenses',
  NOT_AVAILABLE = 'not:available',
  DIALOG_CLICK = 'dialog:click',
  Retrieve_benefit_info = 'retrieve:benefit:info',
  Secure_Cart = 'secure:cart',
}

export enum DataAnalyticsClicksLensCart {
  NAVIGATE_EG_PLPFRAME = 'navigate:eg:plpFrame',
  ADD_CART_EG = 'add:cart:eg',
  UPDATE_CART_EG = 'update:cart:eg',
  NAVIGATE_CART = 'navigate:cart',
  SAVE_FOR_LATER_CART_EG = 'saveForLater:cart:eg',
  ERROR_EG_LENS_GENERIC = 'error:eg:lens:generic',
  ERROR_EG_LENS_MAKEABILITY = 'error:eg:lens:makeability',
  ERROR_EG_LENS_SKU_NOT_FOUND = 'error:eg:lens:skuNotFound',
  ERROR_EG_LENS_SAVE_FOR_LATER = 'error:eg:lens:saveForLater',
  ERROR_EG_LENS_INVALID_PAYLOAD = 'error:eg:lens:invalidPayload',
  ERROR_EG_LENS_SYSTEM = 'error:eg:lens:system',
  ERROR_EG_FIND_FRAME = 'error:eg:find:frame',
  ERROR_LW_CONFIG = 'error:lw:config',
  ERROR_LW_GENERIC = 'error:lw:generic',
  ERROR_LW_LENSES = 'error:lw:lenses',
  ERROR_LW_OPTIONS = 'error:lw:options',
  ERROR_LW_CONTENT = 'error:lw:content',
  ERROR_LW_TREATMENT = 'error:lw:treatment',
  DELETE_CART_EG = 'delete:cart:eg',
  DELETE_CART_CL = 'delete:cart:cl',
  DELETE_CART_PP = 'delete:cart:pp',
  EDIT_CART_EG = 'edit:cart:eg',
  ADD_CART_PROTECTION = 'add:cart:protection',
  DELETE_CART_PROTECTION = 'delete:cart:protection',
  NAVIGATE_CHECKOUT = 'navigate:checkout',
  INCREMENT_CART = 'increment:cart',
  DECREMENT_CART = 'decrement:cart',
}

export enum DataAnalyticsClicksCheckout {
  SELECT_BILLING_ADDRESS = 'select:billing:address',
  SELECT_SHIPPING_ADDRESS = 'select:shipping:address',
  SUBMIT_ORDER = 'submit:order',
  NAVIGATE_CART = 'navigate:cart',
  ADD_SHIPPING_ADDRESS = 'add:shipping:address',
  DELETE_SHIPPING_ADDRESS = 'delete:shipping:address',
  EDIT_SHIPPING_ADDRESS = 'edit:shipping:address',
  REMOVE_SHIPPING_ADDRESS = 'remove:shipping:address',
  DEFAULT_SHIPPING_ADDRESS = 'default:shipping:address',
  EDIT_CHECKOUT_SHIPPING = 'edit:checkout:shipping',
  EDIT_CHECKOUT_BILLING = 'edit:checkout:billing',
  EDIT_CHECKOUT_PAYMENT = 'edit:checkout:payment',
  EDIT_CHECKOUT_REVIEW = 'edit:checkout:review',
  ERROR_SHIPPING_ADDRESS = 'error:shipping:address',
  ERROR_BILLING_ADDRESS = 'error:billing:address',
  Add_PAYMENT = 'add:payment',
  PROPOSITION_65_WARNING = 'proposition:65:warning',
}

export enum DataAnalyticsClicksFavorites {
  ADD_EYEGLASS_FRAME_FAVORITE = 'add:eg:frame:favorite',
  DELETE_EYEGLASS_FRAME_FAVORITE = 'delete:eg:frame:favorite',
  VIEW_EYEGLASS_FRAME_VARIANT = 'view:eg:frame:variant',
  CONFIRM_ORDER = 'confirm:order',
}
export enum LWStepsDataAnalyticsClicks {
  visionRange = 'lw:visionRange',
  usage = 'lw:usage',
  design = 'lw:design',
  material = 'lw:material',
  coating = 'lw:coating',
  addOns = 'lw:addons',
}

export interface DataAnalytics {
  type: DataAnalyticsTypes;
  locations: Array<DataAnalyticsLocations>;
  click?: string;
}

export interface IAnalyticsUserProfile {
  guid?: string;
  gender?: string;
  age?: number;
  toolsUsed?: {
    pdMaster: boolean;
  };
}

export interface IAnalyticsCartInfo {
  customerId: string;
  id: string;
  version: string;
  totalPriceInCentAmount: string;
  cartState: string;
}

export interface IAnalyticsProductInfo {
  productId: string;
  variantId: string;
  sku: string;
  model?: string;
  brand: string;
  toolsUsed?: {
    vtoImpression?: string;
    isVTOUsed?: string;
  };
  productCategory: ProductCategoryKeys;
  features: {
    color?: string;
    gender?: string;
    wearability?: string;
  };
}
export interface IDigitalData {
  page: {
    pageInfo: {
      base: string;
      pageName: string;
    };
    category: any;
  };
  user: {
    // calculate age on basis of dob
    profile: IAnalyticsUserProfile;
    segment: {};
    toolsUsed: {};
  };
  global: {
    feature_name: string;
    guid: '';
  };
  productInfo?: IAnalyticsProductInfo;
  cartInfo?: IAnalyticsCartInfo;
}
export const buildAnalytics = (
  location: DataAnalyticsLocations,
  type: DataAnalyticsTypes = DataAnalyticsTypes.Link,
  parentLocation: Array<DataAnalyticsLocations> = [DataAnalyticsLocations.Page],
  click?: string,
): DataAnalytics => {
  const analytics: DataAnalytics = {
    type,
    locations: [...parentLocation, location],
  };
  if (click) {
    analytics['click'] = click;
  }

  if (analytics.locations[0] !== DataAnalyticsLocations.Page) {
    analytics.locations.unshift(DataAnalyticsLocations.Page);
  }
  return analytics;
};

export const buildAnalytcsButtonClick = (
  click: string,
  location?: DataAnalyticsLocations,
  parentLocation?: Array<DataAnalyticsLocations>,
) =>
  buildAnalytics(
    location || DataAnalyticsLocations.Body,
    DataAnalyticsTypes.Button,
    parentLocation || [],
    click,
  );

const allowedProductAnalyticsPage = [
  InternalLinks.eyeglassPdp,
  InternalLinks.contactsPdp,
  InternalLinks.contacts,
  InternalLinks.lensWizard,
];
const buildProductInfo = (digitalData: IDigitalData) => {
  const analyticsProductList: IAnalyticsProductInfo[] = JSON.parse(
    getSession('analyticsProductList') || '[]',
  );
  const checkProduct = analyticsProductList.filter(
    p => p.productId === getProductIdFromUrl() && p.variantId == getVariantIDFromUrl(),
  );

  if (analyticsProductList.length > 0 && checkProduct) {
    const targetProduct = checkProduct[0];
    if (targetProduct) {
      targetProduct.variantId = String(targetProduct.variantId);
      digitalData.productInfo = targetProduct;
    }
  }
};

const buildUserProfile = (digitalData: IDigitalData) => {
  const userAnalyticsProfile: IAnalyticsUserProfile = getSession(
    'userAnalyticsProfile',
  ) as IAnalyticsUserProfile;
  digitalData.user.profile = JSON.parse(userAnalyticsProfile as string);
};

export const checkPdMeasureProfile = () => {
  const userAnalyticsProfile: IAnalyticsUserProfile = getSession('userAnalyticsProfile')
    ? JSON.parse(getSession('userAnalyticsProfile') as string)
    : ({} as IAnalyticsUserProfile);

  userAnalyticsProfile.toolsUsed = {
    pdMaster: true,
  };
  setProfileToolsUsed(Kp2020ToolsENUM.PD_MASTER);
  setSession('userAnalyticsProfile', JSON.stringify(userAnalyticsProfile));
};

export const checkVirtualTryOn = (productId: string, varientId: string) => {
  const analyticsProductList: IAnalyticsProductInfo[] = JSON.parse(
    getSession('analyticsProductList') || '[]',
  );
  analyticsProductList.forEach(product => {
    if (product && product.productId === productId && product.variantId == varientId) {
      product.variantId = String(product.variantId);
      product.toolsUsed = {
        isVTOUsed: 'true',
      };
    }
    const currentProduct: IAnalyticsProductInfo = getCurrentProductData();
    if (
      currentProduct &&
      currentProduct.productId == productId &&
      currentProduct.variantId == varientId
    ) {
      currentProduct.variantId = String(currentProduct.variantId);
      currentProduct.toolsUsed = {
        isVTOUsed: 'true',
      };
    }
  });
  setSession('analyticsProductList', JSON.stringify(analyticsProductList));
};
export const buildDynamicInfo = (digitalData: IDigitalData) => {
  const urlLink: string = getURIAsString();
  const checkAllowed = allowedProductAnalyticsPage.findIndex(url => url.includes(urlLink));
  checkAllowed >= 0 && buildProductInfo(digitalData);
  buildUserProfile(digitalData);
};
export const setUserProfileToSession = (analyticsUser: IAnalyticsUserProfile) => {
  setSession('userAnalyticsProfile', JSON.stringify(analyticsUser));
};

export const setViewProductInfoToSession = (
  analyticsProduct: IAnalyticsProductInfo,
  maxProductInSession: number,
) => {
  const analyticsProductList: IAnalyticsProductInfo[] = JSON.parse(
    getSession('analyticsProductList') || '[]',
  );
  const newAnalyticsProductList = analyticsProductList.filter(p => {
    if (p.productId !== analyticsProduct.productId) {
      return p;
    } else if (
      p.productId === analyticsProduct.productId &&
      p.variantId != analyticsProduct.variantId
    ) {
      return p;
    }
  });
  if (newAnalyticsProductList.length > maxProductInSession) {
    newAnalyticsProductList.pop();
  }

  newAnalyticsProductList.unshift(analyticsProduct);

  setSession('analyticsProductList', JSON.stringify(newAnalyticsProductList));
};

export const buildProductAnalyticsInfo = (
  productId: string,
  variantId: string | number,
  sku: string,
  model: string,
  brand: string,
  productCategory: ProductCategoryKeys,
  features: {
    color?: string;
    gender?: string;
    wearability?: string;
  },
  toolsUsed?: {
    vtoImpression: string;
  },
): IAnalyticsProductInfo => {
  return {
    sku,
    model,
    brand,
    productCategory,
    features: features,
    productId,
    variantId: String(variantId),
    toolsUsed,
  };
};

declare global {
  interface Window {
    _satellite: {
      kpCustomEvent: (eventName: string, data: any) => void;
    };
  }
}

export enum pdpPageCustomAnalytics {
  PDP_PAGE = 'pdppage',
  FAV_ICON = 'favicon',
  SELECTED = 'selected',
  UN_SELECTED = 'unselected',
  TOOL_VTO = 'Tool:vto',
  Available = 'AVAILABLE',
}

export interface iWebCustomEventParam {
  linkName: string;
  location: string;
  type: string;
  isVTOUsed: 'true' | 'false';
  sku?: string;
}

export const triggerCustomerEvent = (webObj: iWebCustomEventParam, splunkLogger: any) => {
  try {
    const { linkName, location, type, isVTOUsed } = webObj;

    // Check if Adobe Launch and kpCustomEvent are available
    if (
      !window._satellite?.kpCustomEvent ||
      typeof window._satellite.kpCustomEvent !== 'function'
    ) {
      console.warn(
        'Adobe Launch blocked or not loaded or kpCustomEvent function is not available. Custom event will not be tracked.',
      );
      splunkLogger({
        logType: splunk_log_type.WARN,
        data: {
          ...splunk_message.WARN.ADOBE_LAUNCH_BLOCKED,
          context: {
            linkName,
            location,
            type,
            issue: 'Adobe Launch blocked or not loaded or kpCustomEvent function is not available',
          },
        },
      });
      return; // Exit gracefully if Adobe Launch is not available
    }

    window._satellite.kpCustomEvent('trackLinkClick', {
      linkName,
      location,
      type,
      isVTOUsed,
    });
  } catch (error) {
    const err = error as Error;
    splunkLogger({
      logType: splunk_log_type.ERROR,
      data: {
        ...splunk_message.ERROR.TRIGGER_CUSTOMER_EVENT_ERROR,
        error: {
          message: err?.message || String(error),
          stack: err?.stack,
          name: err?.name,
        },
      },
    });
    console.error('Error in triggering custom event', error);
  }
};
